export default function ConditionalWrapper({ condition, wrapper, children }) {
  return children ? (condition ? wrapper(children) : children) : null;
}
